(function() { module.exports = this["wp"]["data"]; }());